import { getErrorMessage } from '@onefootprint/fetch-hosted';
import type { CreateDocumentRequest } from '@onefootprint/request-types';
import { useEffect, useState } from 'react';
import { Logger } from '@/idv2/utils/logger';
import useSubmitDocType from '../../../hooks/use-submit-doc-type';
import { isMobileKind } from '../../../utils/capture';
import { useNonIdDocMachine } from '../../context/non-id-doc-context';
import type { NonIdDocKinds } from '../../types';
import requestKindToDocType from '../../utils/request-kind-to-doc-type';
import InitView from './init-view';
const Init = () => {
  const [state, dispatch] = useNonIdDocMachine();
  const {
    authToken,
    device,
    requirement
  } = state.context;
  const submitDocTypeMutation = useSubmitDocType();
  const {
    isError
  } = submitDocTypeMutation;
  const [numRetries, setNumRetries] = useState(0);
  const retryLimitExceeded = numRetries >= 3;
  useEffect(() => {
    submitDocTypeMutation.mutate({
      body: {
        documentType: requestKindToDocType[requirement.config.kind as NonIdDocKinds] as CreateDocumentRequest['documentType'],
        requestId: requirement.documentRequestId,
        deviceType: isMobileKind(device.type) ? 'mobile' : 'desktop'
      },
      headers: {
        'X-Fp-Authorization': authToken
      }
    }, {
      onSuccess: data => {
        dispatch({
          type: 'contextInitialized',
          payload: {
            id: data.id
          }
        });
      },
      onError: err => {
        const errorMsg = getErrorMessage(err);
        Logger.error(`Failed to submit non id-doc document type ${requirement.config.kind}. Error: ${errorMsg}`, {
          location: 'id-doc-country-and-type-container'
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numRetries]);
  const handleRetry = () => {
    setNumRetries(prev => prev + 1);
  };
  return <InitView isError={isError} retryLimitExceeded={retryLimitExceeded} onRetry={handleRetry} />;
};
export default Init;